import useGetComplaintsTableConfig from './useGetComplaintsTableConfig'

export default useGetComplaintsTableConfig
